<template>
  <div>
    <div data-v-60ee706e="" class="loginwindow transitionBody">
      <div class="login-tips-title">{{ $t('注册') }}</div>
      <div class="login-tips-desc">{{ $t('更多新玩法等你来体验') }}!</div>
      <div data-v-60ee706e="" class="lginner"><img data-v-60ee706e=""
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAA6CAMAAAAQoC6jAAAAxlBMVEUAAADR1+fT2OjT2OfT2OXU2ujS1+fU2ejU2ujV2enT2OnU2ujT2OjS1+fS1+fS1+fU2ejR2OjU2OfU2OjV2ejW2ufV2ujU2efV2unT2ejV2OfU2efT2ubT2+nW3Obb2+3U2efV2uj///82Omn8/P3W2+nP1OXS2OdQU3yMj6nN0+WIi6b5+vzv8fff4+7R1ubj5/Dz9Pnt7/bo6/NDR3Ll6PH3+PqQkqzY3euQk6w6P2yanbT19vqRk62WmLBITHalp7ygorj3N9ErAAAAInRSTlMA8vzZE4D2sHtILaOe9+rpycTDuah1bmpnV1U1KSIeDoGd5tYlqQAAAmlJREFUWMO9mOdyIjEMgE0JJRBIb6QQsUhgll22wBEIJe//UsfB5HQ3sSOHku8nw3xjr2wVKyP5cql6nqtnLNRz59VSOa8cyd8UC6FGorYVItRhoXjj4my8FBDbQRJHvmfFj+IkaCMWXhqC7viSNAWxBw54cUCaLo+/8h2RpuEInBkNSdORfXmniAMfvoU/QDy1LPIuq8cRfJtorLN3Jt816QFsxUDTteHzhZjAliQYfvqQVyH2YWv6GF7977snwSca6f5f32NWx7ATsc4+KiYnx0OOTI59RziGnRnj38A8Eb6BgTewYP430pPaUNRDMPCevpp93XRp3nRx43sIyTPd07TV6oKBXqu18E3JgsKHtbBqXiDMWx2Tsbf6eQomhrqyzqdZ8i1bWxsNvpklUVA2vxLeYgDgYGTfL7AQ4O1KeIF9EIySj+/LhVLPJ20PBKOjD7z2ybMq844lI/vsey6rkk5ANDr6INElVcE+yEbBxx+xos4oAgejkw8iOlM58kE2TqbTiewDn3KqxkG2GyedNO1M2GcPc11lHIQwTTuddAoOwoybcO4udNpyb7PlrsuW5aCs4zt5/xOUrkNQhGPD54/Po3BsVgdb9r3yeZQONl89wcdG4eqVMXDxsVFIDpy+BB8bhfTFCVb0sdGeYLkECD7ByCWAi5Tgk4xcpFTFUkZnm/pmMs5tZVQq9DNj7hEKvbUVWS7mYGS2WJoXWBSapZF1mhCapX21c819N5x7b4n33bQfdqzYffA57Gi2+/B44PGWaW4zgDd/5ImAaVQ/HjFGnpXRxyNGtfEDzyz2h6BaxkLti4eg38yjFL29qJTDAAAAAElFTkSuQmCC"
              alt="" class="gbline" @click="back">
          <div data-v-60ee706e="" class="LoginSquare">
              <div data-v-60ee706e="" class="inputline">
                  <input v-model="name" data-v-60ee706e="" type="text" maxlength="16"
                         :placeholder="$t('请输入手机号或用户名')">
              </div>
              <div data-v-60ee706e="" class="inputline">
                  <input v-model="password" data-v-60ee706e="" maxlength="16" :placeholder="$t('请输入密码')"
                  :type="show1?'text':'password'">
                      <img
                      @click="show1=!show1"
                      v-if="!show1"
                      data-v-65d98e59=""
                      src="/static/image/new/login/eye-icon.png"
                      class="eye"
                      />
                      <img v-else @click="show1=!show1" data-v-65d98e59="" src="/static/image/new/login/eye-icon.png" class="eye">
              </div>

              <div data-v-60ee706e="" class="inputline">
                  <input v-model="confirmPass" data-v-60ee706e="" maxlength="16" :placeholder="$t('请输入确认密码')"
                  :type="show2?'text':'password'">
                      <img
                      @click="show2=!show2"
                      v-if="!show2"
                      data-v-65d98e59=""
                      src="/static/image/new/login/eye-icon.png"
                      class="eye"
                      />
                      <img v-else @click="show2=!show2" data-v-65d98e59="" src="/static/image/new/login/eye-icon.png" class="eye">
              </div>

              <div data-v-60ee706e="" class="inputline">
                  <input v-model="pid" data-v-60ee706e="" type="text" maxlength="16"
                      :placeholder="$t('推荐人')+'(UID)'">
              </div>

              <div data-v-60ee706e="" class="inputline">
                  <input v-model="code" data-v-60ee706e="" type="text" maxlength="16"
                         :placeholder="$t('请输入验证码')">
                  <div data-v-60ee706e="">
                      <img style="cursor: pointer" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="获取验证码..." class="yzm" />
                  </div>
              </div>

              <div data-v-60ee706e="" id="captcha" style="position: relative; top: 10px;"></div>



              <div class="confirm">
                <div data-v-24d6c286="" class="sumbtns" :class="{sbac:isOk}" @click="register">{{  $t('注册') }}</div>
              </div>


              <div @click="back()" data-v-24d6c286="" class="botline">{{ $t('返回登录') }}</div>

          </div>
      </div>
  </div>
  </div>
</template>
<script>
import {translateText} from "../common/utils";
import {getOrCreateDeviceId} from "../common/deviceId";

export default {
  name: 'login',
  data() {
    return {
      show1:false,
      show2:false,
      auto:false,
      registerInfo: {},
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0, //0 是登陆 1是注册
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
      name:'',
      password:'',
      confirmPass:'',
      isOk:false,
      code:''
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = query.type;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  watch:{
    name(){
      this.get_test()
    },
    password(){
      this.get_test()
    },
    confirmPass(){
      this.get_test()
    },
    code(){
      this.get_test()
    },
  },
  methods: {
    get_test(){
      if(this.name&&this.password&&this.confirmPass&&this.code){
        this.isOk=true
      }else{
        this.isOk=false
      }
    },
    back(){
      window.history.go(-1)
    },
    go(s){
      this.$router.push(s)
    },
    async showTost(type = 0, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      if(type==1){
        this.$router.push('reg')
        return
      }
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;

      var info = {
          realname: this.name,
          name: this.name,
          password: this.password,
          confirmPass: this.confirmPass,
          code: this.code,
          paypassword:123456,
          device_id: getOrCreateDeviceId()
      };
      // info = {
      //     realname: "游客试玩",
      //     name: "游客试玩123456",
      //     password: 123456,
      //     confirmPass: 123456,
      //     code: this.code,
      //     paypassword:123456
      // }
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (!info.password || info.password.length < 6) {
        that.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      if (!info.confirmPass || info.confirmPass != info.password) {
        that.$parent.showTost(0, that.$t('两次密码不一致') + '！');
        return;
      }
      // if (!info.realname || info.realname.length < 2) {
      //   that.$parent.showTost(0, '请输入您的真实姓名!');
      //   return;
      // }

      // if (!info.paypassword || info.paypassword.length < 6) {
      //   that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
      //   return;
      // }
      let code = this.code;
      if (!this.code) {
        that.$parent.showTost(0, that.$t('请输入验证码')+'！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.showTost(0, '验证码错误！');
        that.code = '';
        that.changIndex();
        return;
      }
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      console.log(info);
      that.$apiFun.register(info).then(res => {
        that.showTost(1, res.message);
        if (res.code == 200) {
          // localStorage.setItem('token', res.data.api_token);
          // that.$store.commit('changToken');
          // that.$parent.getUserInfo();
          // that.$parent.openDaoTime();

          // that.back();
          that.login()
        }
        that.$parent.hideLoading();
      });
    },
    login() {
      let that = this;
      let info = {
        name:this.name,
        password:this.password
      };
      if (!info.name || !info.password) {
        // that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      // let code = that.loginInfo.code;
      // if (!code) {
      //   that.$parent.showTost(0, '请输入验证码！');

      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$parent.showTost(0, '验证码错误！');
      //   that.loginInfo.code = null;
      //   that.changIndex();
      //   return;
      // }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          localStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/home');
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>

.loginwindow[data-v-60ee706e] {
  width:100%;
  height:100vh;
  background-color:#000;
  background-image:url(/static/image/new/login/login-bg.png);
  background-repeat:no-repeat;
  background-size:100% auto;
  padding: 6rem .4rem 0;
  overflow: auto;
  font-family: PingFang SC;
  color: #fff;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px #1B1B1B inset !important;
    box-shadow: 0 0 0px 1000px #1B1B1B inset !important;
    -webkit-text-fill-color: #fff !important; /* 保持文本颜色继承 */
    transition: background-color 9999s ease-out 0s !important;
  }
  .login-tips-title {
    font-family: HYYakuHei;
    font-size: 0.64rem;
    text-align: left;
  }
  .login-tips-desc {
    font-size: 0.37rem;
    color: #CECECE;
    margin: .24rem 0 .7rem;
  }
}

.loginwindow .lginner[data-v-60ee706e] {
  width:100%;
  box-sizing:border-box;
  border-radius: 0.53rem .53rem 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  padding: .53rem;
  background: rgba(255, 255, 255, .1);
  border: .003rem solid rgba(255, 255, 255, .1);
}
.loginwindow .lginner .gbline[data-v-60ee706e] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  width:1.06667rem
}
.loginwindow .LoginSquare .inputline[data-v-60ee706e] {
  float:left;
  width:100%;
  height:1.31rem;
  background-color: rgba(27, 27, 27, 0.90);
  box-sizing:border-box;
  margin-top:.27rem;
  position:relative;
  display: flex;
  align-items: center;
  border: .003rem solid rgba(255, 255, 255, .1);
  overflow: hidden;
  border-radius: .27rem;
  &:first-child {
    margin-top: 0;
  }
}
.loginwindow .LoginSquare .inputline input[data-v-60ee706e] {
  width:6.66667rem;
  padding-left:.4rem;
  color:#fff !important;
  text-align:left;
  line-height:1.12rem;
  font-size:.37333rem;
  border:none !important;
  outline:none !important;
  z-index:2;
  border-radius:.26667rem;
  background: rgba(27, 27, 27, 0.90) !important;
  &::placeholder {
    color: #bbb;
  }
}
.loginwindow .LoginSquare .inputline div[data-v-60ee706e] {
  width:50%;
  height:1.2rem;
  position:absolute;
  z-index:10;
  right:0;
  border-radius:.26667rem
}
.loginwindow .LoginSquare .inputline .eye{
  width:0.48rem;
  margin-left:.4rem;
  position: relative;
  z-index: 10;
}
.loginwindow .LoginSquare .inputline .yzm[data-v-60ee706e] {
  width:1.89333rem;
  height:.66667rem;
  border:.02667rem solid #e3e4ea;
  float:right;
  margin-top:.21333rem;
  margin-right:.4rem;
  right:0;
  position:absolute;
  z-index:3
}
.loginwindow .LoginSquare .confirm {
  display:flex;
  justify-content:center;
  width: 100%;
}
.loginwindow .LoginSquare .confirm .sumbtns {
  height:1.23rem;
  color:#fff;
  width: 100%;
  border-radius:.8rem;
  background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8);
  margin-top:.53rem;
  font-size: 0.43rem;
  font-weight:700;
  text-align: center;
  line-height: 1.23rem;
  overflow: hidden;
}
.loginwindow .LoginSquare .confirm .sbac[data-v-60ee706e] {
  opacity:1
}
.loginwindow .LoginSquare .botline {
  font-size: 0.32rem;
  color: #BBBBBB;
  height:1.23rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}



.yzm {
  width: 1.89333rem;
  height: auto;
  margin-top: .21333rem;
  margin-right: .4rem;
  right: 0;
  position: absolute;
  z-index: 3;
}

.sbac[data-v-24d6c286] {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/reg2.vue